export const ACTIONS_PATHS = {
  list: "/agents/actions",
  plan: (planId: string) => `/agents/actions/${planId}`,
};
